// src/components/dashboard/charts/ActivityPatternChart.js
import React, { forwardRef } from 'react';
import { Line } from 'react-chartjs-2';

const ActivityPatternChart = forwardRef(({ data }, ref) => {
    if (!data) return null;

    // Ensure data is an array of 24 hour values
    const hourlyData = Array.isArray(data) ? data : Array(24).fill(0);

    const hourLabels = Array.from({ length: 24 }, (_, i) =>
        `${String(i).padStart(2, '0')}:00`
    );

    const chartData = {
        labels: hourLabels,
        datasets: [{
            label: 'Message Volume',
            data: hourlyData,
            borderColor: 'rgb(147, 51, 234)',
            backgroundColor: 'rgba(147, 51, 234, 0.1)',
            fill: true,
            tension: 0.4
        }]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                mode: 'index',
                intersect: false,
                callbacks: {
                    title: function (context) {
                        return `Time: ${context[0].label}`;
                    },
                    label: function (context) {
                        return `Messages: ${context.raw}`;
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)'
                }
            },
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    maxRotation: 45,
                    minRotation: 45
                }
            }
        }
    };

    return <Line data={chartData} options={options} ref={ref} />;
});

export { ActivityPatternChart };